import { ElementProps, ActionIconProps, ActionIcon } from '@mantine/core';
import clsx from 'clsx';
import { useUnit } from 'effector-react';
import { forwardRef } from 'react';
import { ModalFormModel } from 'shared/lib';

export type ModalFormActionIconProps<TModalData> = ActionIconProps &
	ElementProps<'button', keyof ActionIconProps> & {
		modalData: TModalData;
		'data-test-id'?: string;
	};

export const createModalFormActionIcon = <TModalData, TFormValues extends Record<string, unknown>>(
	modalFormModel: ModalFormModel<TModalData, TFormValues>,
) => {
	const ModalFormActionIcon = forwardRef<HTMLButtonElement, ModalFormActionIconProps<TModalData>>(
		({ modalData, className, children, onClick, ...props }, ref) => {
			const clicked = useUnit(modalFormModel.modalButtonClicked);

			return (
				<ActionIcon
					ref={ref}
					className={clsx('modal-form-action-icon', className)}
					onClick={(event) => {
						clicked(modalData);
						onClick?.(event);
					}}
					{...props}
				>
					{children}
				</ActionIcon>
			);
		},
	);

	return ModalFormActionIcon;
};
